import script from "./KnowledgeView.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeView.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgeView.vue?vue&type=style&index=0&id=5aa41b2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa41b2b"]])

export default __exports__